import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';


export default function Delete() { 
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => { 
        axios.post('http://localhost:5000/Roles/DeleteRole', { id: id})
            .then((response) => { 
                if (response.status === 200) { 
                    navigate('/Admin/Roles')
                }          
            })
            .catch((error) =>  {
                console.log(error);
            })
    })
}